export default __webpack_public_path__ + "media/images/icons/sort-amount-up-alt-solid-aae5bb8054e064150c91430dccd4f651.svg";